<template>
  <div class="page-box">
    <div class="banner-box">
      <video-carousel></video-carousel>
    </div>
    <div class="bg-item" @click="$router.push('/product')">
      <div class="item-box">
        <div class="item-title-box">
          <h2 class="item-title">产品中心</h2>
        </div>
        <div class="item-content">
          <div class="swiper-case">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <el-card :body-style="{ padding: '0px' }" shadow="hover">
                  <div class="img-box">
                    <img
                      src="@/assets/ds/images/轴类零部件/1493950541_.jpg"
                      class="image"
                    />
                  </div>
                  <div style="padding: 15px">
                    <h4>轴类零部件</h4>
                  </div>
                </el-card>
              </div>
              <div class="swiper-slide">
                <el-card :body-style="{ padding: '0px' }" shadow="hover">
                  <div class="img-box">
                    <img
                      src="@/assets/ds/images/等离子喷涂/1492583076_.jpg"
                      class="image"
                    />
                  </div>
                  <div style="padding: 15px">
                    <h4>等离子喷涂</h4>
                  </div>
                </el-card>
              </div>
              <div class="swiper-slide">
                <el-card :body-style="{ padding: '0px' }" shadow="hover">
                  <div class="img-box">
                    <img
                      src="@/assets/ds/images/辊筒类零部件/1492582985_.jpg"
                      class="image"
                    />
                  </div>
                  <div style="padding: 15px">
                    <h4>辊筒类零部件</h4>
                  </div>
                </el-card>
              </div>
              <div class="swiper-slide">
                <el-card :body-style="{ padding: '0px' }" shadow="hover">
                  <div class="img-box">
                    <img
                      src="@/assets/ds/images/等离子陶瓷/1492583164_.jpg"
                      class="image"
                    />
                  </div>
                  <div style="padding: 15px">
                    <h4>等离子陶瓷</h4>
                  </div>
                </el-card>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-item"
      style="margin-bottom: 20px"
      @click="$router.push('/device')"
    >
      <div class="item-box">
        <div class="item-title-box">
          <h2 class="item-title">设备中心</h2>
        </div>
        <div class="item-content">
          <div class="swiper-case">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <el-card :body-style="{ padding: '0px' }" shadow="hover">
                  <div class="img-box">
                    <img
                      src="@/assets/ds/images/设备展示/1494227134_.jpg"
                      class="image"
                    />
                  </div>
                  <div style="padding: 15px">
                    <h4>设备展示</h4>
                  </div>
                </el-card>
              </div>
              <div class="swiper-slide">
                <el-card :body-style="{ padding: '0px' }" shadow="hover">
                  <div class="img-box">
                    <img
                      src="@/assets/ds/images/设备展示/1494227142_.jpg"
                      class="image"
                    />
                  </div>
                  <div style="padding: 15px">
                    <h4>设备展示</h4>
                  </div>
                </el-card>
              </div>
              <div class="swiper-slide">
                <el-card :body-style="{ padding: '0px' }" shadow="hover">
                  <div class="img-box">
                    <img
                      src="@/assets/ds/images/设备展示/1494227109_.jpg"
                      class="image"
                    />
                  </div>
                  <div style="padding: 15px">
                    <h4>设备展示</h4>
                  </div>
                </el-card>
              </div>
              <div class="swiper-slide">
                <el-card :body-style="{ padding: '0px' }" shadow="hover">
                  <div class="img-box">
                    <img
                      src="@/assets/ds/images/设备展示/1494227126_.jpg"
                      class="image"
                    />
                  </div>
                  <div style="padding: 15px">
                    <h4>设备展示</h4>
                  </div>
                </el-card>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="service-box">
      <div class="service-title">
        <h2>上海轴加工，上海滚筒轴加工厂家</h2>
      </div>
      <a class="clearfix">
        <div class="service-btn" @click="$router.push('/aboutme')">
          合作咨询
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import videoCarousel from "@/views/video-carousel";

export default {
  name: "Home",
  components: { videoCarousel },
  data() {
    return {
      currentDate: new Date(),
      images: {
        zllbj: [
          "轴类零部件/1493950541_.jpg",
          "轴类零部件/1493950652_.jpg",
          "轴类零部件/1493950605_.jpg",
          "轴类零部件/1492582685_.jpg",
          "轴类零部件/1493950673_.jpg",
          "轴类零部件/1493950716_.jpg",
          "轴类零部件/1492582719_.jpg",
          "轴类零部件/1493950595_.jpg",
          "轴类零部件/1492582694_.jpg",
          "轴类零部件/1493950662_.jpg",
          "轴类零部件/1492582728_.jpg",
          "轴类零部件/1493950530_.jpg",
          "轴类零部件/1492582704_.jpg",
          "轴类零部件/1492582712_.jpg",
          "轴类零部件/1493950642_.jpg",
          "轴类零部件/1493950585_.jpg",
          "轴类零部件/1493950507_.jpg",
          "轴类零部件/1492582744_.jpg",
          "轴类零部件/1492582752_.jpg",
          "轴类零部件/1493950726_.jpg",
          "轴类零部件/1493950565_.jpg",
          "轴类零部件/1493950705_.jpg",
          "轴类零部件/1493950683_.jpg",
          "轴类零部件/1493950695_.jpg",
          "轴类零部件/1493950552_.jpg",
          "轴类零部件/1492582674_.jpg",
          "轴类零部件/1492582736_.jpg",
          "轴类零部件/1493950575_.jpg",
          "轴类零部件/1493950735_.jpg",
          "轴类零部件/1493950519_.jpg",
        ],
        dlzpt: [
          "等离子喷涂/1492583076_.jpg",
          "等离子喷涂/1492583144_.jpg",
          "等离子喷涂/1492583124_.jpg",
          "等离子喷涂/1492583115_.jpg",
          "等离子喷涂/1492583135_.jpg",
          "等离子喷涂/1492583086_.jpg",
          "等离子喷涂/1492583096_.jpg",
          "等离子喷涂/1492583106_.jpg",
        ],
        ktllbj: [
          "辊筒类零部件/1492582985_.jpg",
          "辊筒类零部件/1492583033_.jpg",
          "辊筒类零部件/1492583012_.jpg",
          "辊筒类零部件/1492582976_.jpg",
          "辊筒类零部件/1492582995_.jpg",
          "辊筒类零部件/1492583022_.jpg",
        ],
        dlztc: ["等离子陶瓷/1492583164_.jpg"],
        sbzs: [
          "设备展示/1494227134_.jpg",
          "设备展示/1494227142_.jpg",
          "设备展示/1494227109_.jpg",
          "设备展示/1494227126_.jpg",
          "设备展示/1494227150_.jpg",
        ],
      },
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="less">
@import "swiper/swiper.less";
@import "@/style/index.less";
.item-content {
  background-color: rgba(0, 0, 0, 0.056);
  padding: 0 40px;
  border-radius: 10px;
}
.swiper-case {
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: left;

  .swiper-slide {
    width: 293px;
    height: 270px;
    display: flex;
    justify-content: center;

    .el-card {
      height: 98%;
      border-radius: 10px;
    }

    h4 {
      margin: 20px 0;
      display: flex;
      justify-content: center;
    }

    .img-box {
      width: 100%;
      height: 192px;
      overflow: hidden;
    }

    img {
      display: block;
      width: 100%;
      height: 192px;
      object-fit: cover;
      transition: all 0.3s;
    }

    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
}
</style>
